$(document).ready(function() {
    // search page
     if($('#searchfield').val() != '') {
         $('#searchclear').removeClass('d-n');
     } else {
         $('#searchclear').addClass('d-n');
     }

     $('#searchclear').click(function() {
         $('#searchfield').val('');
         $('#searchclear').addClass('d-n');
     });
     $('.search-container').on('keyup keypress blur change', function() {
         if($('#searchfield').val() != '') {
             $('#searchclear').removeClass('d-n');
         } else {
             $('#searchclear').addClass('d-n');
         }
     });
});
